export default __webpack_public_path__ + "static/media/customer-support-illustration.a5d89815.svg";